import { Component, inject } from '@angular/core';
import { Router, RouterOutlet } from '@angular/router';
import { HeaderComponent } from './core/components/header/header.component';
import { FooterComponent } from './core/components/footer/footer.component';
import { SideBarComponent } from './core/components/side-bar/side-bar.component';
import { CalService } from './core/services/cal.service';
import { CommonService } from './services/common.service';
import { BASIC_MODULES } from './shared';
import { HydrotestService } from './feature/service/hydrotest.service';
import { LoaderComponent } from './core/components/loader/loader.component';

@Component({
    selector: 'app-root',
    imports: [HeaderComponent, FooterComponent, BASIC_MODULES, SideBarComponent, LoaderComponent],
    providers: [],
    templateUrl: './app.component.html',
    styleUrl: './app.component.scss'
})
export class AppComponent {
  title = 'Hydrostatic-app';

  private calService = inject(CalService);
  welcomeName!: string;

  constructor(public commonService: CommonService,
    private hydrotestService: HydrotestService,
    private router: Router
  ) {
    this.calService.getFirstName().subscribe(name => {
      this.welcomeName = name;
    });
  }

  ngOnInit() {
    // Initialize authentication on startup
    this.initializeAuthentication();
  }
  isLogin: boolean = false;
  private async initializeAuthentication() {
    try {
      this.commonService.isAuthenticatingSignal.set(true);
      // Sign in user
      const user = await this.calService.signIn();
      // Get token and store it
      const token = await this.calService.getAADToken();     

      if (token) {
        // Store token in session storage
        window.sessionStorage.setItem('AuthToken', token as string);
        this.commonService.isAuthenticatingSignal.set(true);

        this.isLogin =true;
        let currentUser = localStorage.getItem('currentUser');
       // if (!currentUser) {
          this.hydrotestService.login().subscribe({
            next: (response) => {
              // Handle successful login response
              // console.log("Login successful:", response);
              localStorage.setItem('currentUser', response.userName);
              localStorage.setItem('admin', response.isAdmin);
              this.commonService.isAdminSignal.set(response.isAdmin);
              // this.router.navigate(['/home']);
            },
            error: (error) => {
              // Handle login error
            }
          });
       // }
      } else {
        console.warn("No authentication token received");
        this.commonService.isAuthenticatingSignal.set(true);
      }

      // // Get token and store it
      const powerbiToken = await this.calService.getPowerBiAADToken();
      if (powerbiToken) {
        // Store token in session storage
        window.sessionStorage.setItem('PowerBiAuthToken', powerbiToken as string);
      }
      
    } catch (error) {
      console.error("Authentication failed:", error);
      this.commonService.isAuthenticatingSignal.set(false);
    } finally {
      // this.isAuthenticating = false;
    }
  }
}
